import { type OnboardingDataField, type OnboardingDataFieldType } from '@gb-ticket/shared-types';

export const ONBOARDING_DATA_FIELD_TYPE_LABEL: Record<OnboardingDataFieldType, string> = {
  short_text: 'Kurztext',
  long_text: 'Langtext',
  date: 'Datum',
  boolean: 'Ja/Nein',
  choice: 'Auswahl',
};

export function onboardingFieldSubmission(
  fields: OnboardingDataField[],
  values: Record<string, unknown>,
): Record<string, unknown> {
  const next: Record<string, unknown> = {};
  for (const field of fields) {
    const raw = values[field.key];
    if (field.type === 'boolean') {
      if (raw === undefined) {
        if (field.required) {
          next[field.key] = false;
        }
        continue;
      }
      next[field.key] = raw === true;
      continue;
    }
    if (raw === undefined || raw === null || raw === '') {
      continue;
    }
    next[field.key] = raw;
  }
  return next;
}
